import React from 'react'
import Icon from './Icon'

const CheckBox = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m16.6 28.4l15-15-2.3-2.5-12.7 12.7-5.9-5.9-2.3 2.3z m15-23.4c1.9 0 3.4 1.6 3.4 3.4v23.2c0 1.8-1.5 3.4-3.4 3.4h-23.2c-1.9 0-3.4-1.6-3.4-3.4v-23.2c0-1.8 1.5-3.4 3.4-3.4h23.2z" />
    </g>
  </Icon>
)

export default CheckBox



// WEBPACK FOOTER //
// ./icons/CheckBox.js